<template>
  <div class="ml-0.75 flex-row sm:items-center flex items-center">
    <div
      class="flex items-center gap-3"
      v-for="button in buttonList"
      :key="button.id"
    >
      <CustomButton
        class="mr-5 leading-4! tracking-[0.2px]"
        :label="button.label"
        :variant="button.isActive ? 'primary' : 'primary_outlined'"
        @click="handleChangeList(button)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Button } from "../../types/general";
import CustomButton from "./CustomButton.vue";

const props = defineProps<{
  buttonList: Button[];
}>();

const emit = defineEmits(["changeList"]);

function handleChangeList(button: Button) {
  emit("changeList", button);
}
</script>
